import { useFormContext } from "./formElements";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export function FansInspectionChecklist(props) {
  const element = props.value;
  const { onChange } = useFormContext();

  const removeItem = (index) => {
    element.items.splice(index, 1);
    onChange({ ...element });
  };

  const addItem = () => {
    const template =
      element.items && element.items.length > 0
        ? {
            ...element.items[0],
            label: "",
          }
        : {
            label: "",
            type:"checkbox",
            checked:false,
            value:""
          };

    element.items = [...element.items, template];
    onChange({ ...element });
  };

  // title i label są opcjonalne - pokazujemy je tylko, gdy występują w modelu
  const hasTitle = Object.prototype.hasOwnProperty.call(element, "title");
  const hasLabel = Object.prototype.hasOwnProperty.call(element, "label");

  return (
    <div>
      {hasTitle && (
        <Form.Control
          type="text"
          className="border-0 bg-transparent fs-5 fw-bold mt-3"
          value={element.title ?? ""}
          placeholder="Tytuł"
          onChange={(event) => {
            element.title = event.target.value;
            onChange(element);
          }}
        />
      )}
      {hasLabel && (
        <Form.Control
          type="text"
          className="border-0 bg-transparent"
          value={element.label ?? ""}
          placeholder="Etykieta"
          onChange={(event) => {
            element.label = event.target.value;
            onChange(element);
          }}
        />
      )}
      <h6 className="mt-4">Lista kontrolna:</h6>
      <ol>
        {element.items.map((item, idx) => (
          <li key={idx} className="mt-2">
            <Row>
              <Col>
                <Form.Control
                  className={"bg-transparent "}
                  type="text"
                  as={"textarea"}
                  value={item.label}
                  placeholder=""
                  onChange={(event) => {
                    const newVal = event.target.value;
                    item.label = newVal;
                    onChange(element);
                  }}
                />
              </Col>
              <Col xs={"auto"} className="d-flex align-items-start gap-2">
                <Form.Check
                  type="checkbox"
                  label={item.checked ? "POZYTYWNA" : "NEGATYWNA"}
                  checked={item.checked}
                  onChange={(event) => {
                    const newVal = event.target.checked;
                    item.checked = newVal;
                    onChange(element);
                  }}
                />
                <Button
                  variant="outline-danger"
                  size="sm"
                  className="mt-1"
                  onClick={() => removeItem(idx)}
                  title="Usuń pozycję"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </Col>
            </Row>
          </li>
        ))}
      </ol>
      <Button
        variant="outline-primary"
        size="sm"
        className="mt-2"
        onClick={addItem}
      >
        Dodaj pozycję
      </Button>
    </div>
  );
}
